import loadable from '@loadable/component';
import Loading from '../components/Loader';

const DoeGate = loadable(() => import(/* webpackChunkName: "login" */ '../pages/Doe'), {
  fallback: Loading,
});

export default DoeGate;
